export const getFormattedDate = (date?: string): string => {
  if (!date) return '';
  return new Date(date).toLocaleDateString('fr-CA');
};

export const getFormattedTime = (date?: string): string => {
  if (!date) return '';
  return new Date(date).toLocaleTimeString('en-US');
};
